/** Structured console logging for workspace → runtime → discovery pipeline. */

function stamp() {
  return new Date().toISOString();
}

function log(event, payload = {}) {
  // eslint-disable-next-line no-console
  console.info(`[Runtime] ${event}`, { at: stamp(), ...payload });
}

export function logWorkspaceChanged(workspace) {
  log("Workspace Changed", {
    connectionId: workspace?.connectionId || null,
    connectionName: workspace?.connectionName || null,
    projectId: workspace?.projectId || null,
    projectName: workspace?.projectName || null,
    environment: workspace?.environment || null,
  });
}

export function logRuntimeCreated({ connectionId, projectId, appName, runtimeVersion }) {
  log("Runtime Created", {
    connectionId,
    projectId,
    appName,
    "Runtime Version": runtimeVersion,
  });
}

export function logRuntimeDisposed({ connectionId, projectId, runtimeVersion }) {
  log("Runtime Disposed", {
    connectionId,
    projectId,
    "Runtime Version": runtimeVersion,
  });
}

export function logRuntimeRefreshCompleted({ connectionId, projectId, runtimeVersion }) {
  log("Runtime Refresh Completed", {
    connectionId,
    projectId,
    "Runtime Version": runtimeVersion,
  });
}

export function logDiscovery({
  discoverySource,
  connectionId,
  projectId,
  collectionsDiscovered,
  collectionsRendered,
  registryUpdated,
}) {
  log("Discovery", {
    "Discovery Source": discoverySource,
    connectionId,
    projectId,
    "Collections Discovered": collectionsDiscovered,
    "Collections Rendered": collectionsRendered,
    "Registry Updated": registryUpdated,
  });
}
